<template>
    <div>
        <span class="b-admin-table__icon-true" v-if="history.is_confirmed">
            <i class="fa fa-check"></i>
        </span>
        <span class="b-admin-table__icon-false" v-if="history.is_canceled">
            <i class="fa fa-times"></i>
        </span>

        <span v-if="history.is_verification" class="b-admin-table__icon-false">
            <button type="button"
                    @click="confirmHistory"
                    v-if="update_permission"
                    class="btn btn-primary btn-xs"
                    v-text="trans('confirm_button')"
            ></button>

            <button type="button"
                    @click="cancelHistory"
                    v-if="update_permission"
                    class="btn btn-primary btn-xs"
                    v-text="trans('cancel_button')"
            ></button>
        </span>
    </div>
</template>

<script>
    let Functions = require("../../Functions");

    export default {
        props: ['history', 'current_route', 'update_permission', 'translations'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        methods: {
            trans(name, path = 'stock') {
                return Functions.trans(this.translations, name, path);
            },
            confirmHistory: function () {
                if (confirm(this.trans('to_confirm_history'))) {
                    this.sendRequest('confirm', this.history.id);
                }
            },
            cancelHistory: function () {
                if (confirm(this.trans('to_cancel_history'))) {
                    this.sendRequest('cancel', this.history.id);
                }
            },
            sendRequest: function (action, item_id) {
                this.$http.post(`${this.current_route}/${action}`, {
                    id: item_id
                }).then(function () {
                    this.$root.$emit('update-table');
                });
            }
        },
    }
</script>
